export const useFormatDate = _ref => {
  let {
    locale
  } = _ref;
  return date => {
    if (!date) {
      return '';
    }
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(date);
  };
};
//# sourceMappingURL=useFormatDate.js.map